<script context="module" lang="ts">
  export type LiveBidsIndicatorStatus = 'online' | 'connecting' | 'offline';
</script>

<script lang="ts">
  import Tooltip from '$lib/client/Tooltip.svelte';
  import IconBroadcastOn from '~icons/tabler/broadcast';
  import IconBroadcastOff from '~icons/tabler/broadcast-off';

  export let status: LiveBidsIndicatorStatus = 'connecting';
</script>

<Tooltip>
  <div class="d-flex align-items-center gap-1 border rounded-pill px-2 py-1" slot="trigger">
    <div
      class="d-inline-flex"
      class:text-danger={status === 'offline'}
      class:text-warning={status === 'connecting'}
      class:text-success={status === 'online'}
    >
      {#if status === 'offline'}
        <IconBroadcastOff style="font-size: 0.875em;" />
      {:else}
        <IconBroadcastOn style="font-size: 0.875em;" />
      {/if}
    </div>
    <span class="fs-8 text-secondary" style="cursor: default;">
      {#if status === 'online'}
        Live bids
      {:else if status === 'connecting'}
        Connecting...
      {:else}
        Disconnected
      {/if}
    </span>
  </div>

  <p style="max-width: 50vw">
    {#if status === 'online'}
      Real-time updates: bids are being updated live as they occur.
    {:else if status === 'connecting'}
      Connecting: bids will update shortly once connected. If it takes too long, consider refreshing the page.
    {:else}
      Disconnected: bids won't update. Please refresh the page or try again later.
    {/if}
  </p>
</Tooltip>
